import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import { find, get } from 'lodash';

import entityToHtml from '../../util/remove_html_markup';
import { SET_CLIENT_STATE, PAGE_LIST, CLIENT_STATE } from '../../graphqls';

export default function SubHeader() {
  const { loading: loadingPageList, data: { pageList = [] } = {} } = useQuery(PAGE_LIST);
  const { loading: loadingClientState, data: { sideMenu, selectedPage } = {} } = useQuery(CLIENT_STATE);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const { pathname } = useLocation();

  useEffect(() => {
    setState({ variables: { selectedPage: get(find(pageList, ['id', pathname.split('/')[2]]), 'title') || 'Homepage' } });
  }, []);

  const onTogglePageList = () => {
    if (pageList.length) {
      setState({ variables: { sideMenu: sideMenu ? '' : 'pageListView' } });
    }
  };
  const pageListLabel = pageList.length ? 'View All Pages' : '';

  if (loadingPageList || loadingClientState) {
    return '';
  }

  return (
    <div className="app-secondary-header main-secondary-header">
      <button type="button" className="hollow-btn page-list-btn" onClick={onTogglePageList}>
        <FontAwesomeIcon icon={['fal', 'book-open']} />
        <span>{pageListLabel}</span>
        <span className="current-page">
          Current Page:
          <strong>{selectedPage === 'HomePage' ? 'Homepage' : entityToHtml(selectedPage)}</strong>
        </span>
      </button>
    </div>
  );
}
